import { CURRENCY_MODEL_CLASS_NAME } from 'models/daos/currency/constants'
import { getCurrencyUserUtil } from 'models/daos/user/utils/get-currency'
import {
  CURRENCIES_DOMAIN,
  CURRENCIES_PATH
} from 'modules/currencies/constants'
import {
  getSelectedCurrencySelector,
  hasCurrenciesSelect
} from 'modules/currencies/selectors'
import {
  loadRatesCurrenciesUtil,
  toObjectsCurrencyUtil
} from 'modules/currencies/utils'
import { loadSuccessLegacyReduxAction } from 'modules/redux/actions/legacy/load'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'
import REDUX_OPTION from 'modules/redux/constants/option'
import { getCurrentUserSettingsSelector } from 'modules/settings/selectors'
import getCurrentUserSelector from 'modules/users/selectors/get-current'
import { logUtil } from 'packages/src'

/**
 * Loads the currency rates.
 * @returns {Function}
 */
function loadRatesCurrenciesAction () {
  return (dispatch, getState) => {
    const hasCurrencies = hasCurrenciesSelect(getState())
    if (hasCurrencies) {
      logUtil('loadRatesCurrenciesAction').debug('[noop] already loaded')
      return
    }
    logUtil('loadRatesCurrenciesAction').debug('[start]')
    return loadRatesCurrenciesUtil()
      .then(rateObj => {
        const options = {
          [REDUX_OPTION.OMIT_STATUS]: true
        }
        dispatch(loadSuccessLegacyReduxAction({
          path: CURRENCIES_DOMAIN,
          data: toObjectsCurrencyUtil(rateObj),
          className: CURRENCY_MODEL_CLASS_NAME,
          options
        }))
      })
      .catch((error) => {
        logUtil('loadRatesCurrenciesAction').error('error=', error)
      })
  }
}

/**
 * Inits the selected currency.
 * @param  {String|null} value
 * @returns {Function}
 */
function initCurrenciesAction () {
  return (dispatch, getState) => {
    // If there is no current user, noop
    const currentUser = getCurrentUserSelector()(getState())
    if (!currentUser) {
      return
    }
    // If the settings has a currency, get it
    const settings = getCurrentUserSettingsSelector()(getState())
    let value
    if (settings) {
      value = settings.data.currency
    }
    // If the settings doesn't have a currency,
    // get it from the current user's location
    if (!value) {
      value = getCurrencyUserUtil(currentUser)
    }
    // If the currency has not changed, no-op
    const selected = getSelectedCurrencySelector()(getState())
    if (value === selected) {
      return
    }
    const path = CURRENCIES_PATH.SELECTED
    return dispatch(updateLegacyReduxAction({
      path,
      value
    }))
  }
}

/**
 * Updates the selected currency.
 * @param  {string} value
 * @returns {Function}
 */
function updateSelectedCurrencyAction (value) {
  // Update the selected currency
  const path = CURRENCIES_PATH.SELECTED
  return updateLegacyReduxAction({
    path,
    value
  })
}

/**
 * Resets the domain to its initial state.
 * @param  {Object} value
 * @returns {Function}
 */
function setCurrenciesAction (value) {
  return updateLegacyReduxAction({
    path: CURRENCIES_DOMAIN,
    value
  })
}

export {
  loadRatesCurrenciesAction,
  initCurrenciesAction,
  updateSelectedCurrencyAction,
  setCurrenciesAction
}
